import React, { useState, useEffect } from 'react';
import { makeStyles, Typography, Grid, MenuItem, FormControl, Button, TextField, Select } from '@material-ui/core';
import usePermissions from 'hooks/permissions-hooks';
import SearchIcon from '@material-ui/icons/Search';
import ManagersSerialDashboardResults from 'components/business/local-manager/ManagersSerialDashboardResults';
import { useAlerts } from 'hooks/alerts-hooks';
import { roles } from '../cassandra-shared-js/roles';

const useStyles = makeStyles({
  title: {
    margin: '0px 0px 5px 5px',
    color: 'rgb(100, 141, 174)',
    fontSize: 35,
  },
  button: {
    margin: '6px 15px 0px 0px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
  selectLocation: {
    fontSize: 18,
    color: 'rgb(100, 141, 174)',
    margin: '0px 0px 20px 5px',
  },
  searchBox: {
    fontSize: 18,
    color: 'rgb(100, 141, 174)',
    margin: '6px 0px 0px 5px',
  },
});

function ManagerSerialDashboardPage() {
  const classes = useStyles();
  const [ country, setCountry ] = useState('GR');
  const [ searchSerial, setSearchSerial ] = useState('');
  const [ searchField, setSearchField ] = useState('');
  const { userHasRole, role } = usePermissions();
  const { alertError } = useAlerts();
  // Select Country
  useEffect(() => {
    if (userHasRole(roles.AL_MANAGER)) {
      setCountry('AL');
    } else if (userHasRole(roles.ADMINISTRATOR_ROLE)) {
      setCountry('GR');
    }
  }, [ role ]);

  const handleSearch = (value) => {
    if (value.length !== 8) {
      alertError('Serial must have 2 letters and 6 numbers');
    }
    setSearchSerial(value);
  };

  // Start search with Enter key
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (e.target.value.length !== 8) {
        alertError('Serial must have 2 letters and 6 numbers');
      }
      setSearchSerial(e.target.value);
    }
  };

  return (
    <>
      <Grid container spacing={ 2 } alignItems='center'>
        <Grid item xs={ 12 }>
          <div className={ classes.title }>
            Serial Dashboard
          </div>
        </Grid>
        <Grid container spacing={ 2 } alignItems='center'>
          {userHasRole(roles.ADMINISTRATOR_ROLE) && (
            <Grid item xs={ 6 } md={ 2 } display='flex'>
              <FormControl style={ { width: '100%' } } className={ classes.selectLocation }>
                <Typography
                  variant='subtitle'
                  id='location-select-label'
                >
                  Location:
                </Typography>
                <Select
                  variant='outlined'
                  size='small'
                  labelId='country-select-label'
                  id='country-select'
                  value={ country }
                  onChange={ (e) => { setCountry(e.target.value); } }
                >
                  <MenuItem value='GR'>Greece</MenuItem>
                  <MenuItem value='AL'>Albania</MenuItem>
                  <MenuItem value='IN'>India</MenuItem>
                  <MenuItem value='IQ'>Iraq</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={ 6 } md={ 2 } display='flex'>
            <TextField
              className={ classes.searchBox }
              id='search-bar'
              size='medium'
              value={ searchField }
              onChange={ (e) => { setSearchField(e.target.value); } }
              onKeyPress={ (e) => { handleKeyPress(e); } }
              label='Enter Serial Number'
              variant='outlined'
              defaultValue='20px Text'
            />
          </Grid>
          <Grid item xs={ 6 } display='flex'>
            <Button
              className={ classes.button }
              variant='outlined'
              size='large'
              onClick={ () => { handleSearch(searchField); } }
            >
              <SearchIcon />
              SEARCH
            </Button>

            { searchField.length > 0
            && (

              <Button
                className={ classes.button }
                variant='outlined'
                size='large'
                onClick={ () => {
                  setSearchSerial('');
                  setSearchField('');
                } }
              >
                CLEAR
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
      {searchSerial.length >= 8
      && <ManagersSerialDashboardResults searchSerial={ searchSerial } country={ country } />}
    </>
  );
}

export default ManagerSerialDashboardPage;
